import type { EscalationEvent } from "@redotech/merchant-sdk/rpc/schema/agents/merchant-support-agent/escalation";

export interface HumanMessage {
  id: string;
  body: string;
  authorName: string | null;
  authorId: string;
  authorAvatarUrl: string | null;
  createdAt: number;
  attachments: { name?: string; url: string; contentType?: string }[];
}

/**
 * Convert a Notice human-message event into a `HumanMessage`, or null
 * when required fields are missing.
 */
export function humanMessageFromEvent(
  event: EscalationEvent,
): HumanMessage | null {
  if (event.type !== "human-message" || !event.messageId || !event.authorId) {
    return null;
  }
  return {
    id: event.messageId,
    body: event.body ?? "",
    authorName: event.authorName ?? null,
    authorId: event.authorId,
    authorAvatarUrl: event.authorAvatarUrl ?? null,
    createdAt: event.createdAt ?? Date.now() / 1000,
    attachments: event.attachments ?? [],
  };
}
